import React, { useState, useEffect, memo, useRef } from 'react';
import { TextField, TextFieldProps } from '@material-ui/core';

/**
 *
 * @param {TextFieldProps & {number: delay, value: string, onChange: (event: {target: {value: string}}) => void}} param
 * @returns
 */
export const DebounceTextField2 = ({
  delay = 500,
  value,
  onChange,
  actualValue = () => {},
  ...props
}) => {
  const [tempVal, setTempVal] = useState(value ?? '');
  const inputRef = useRef(null);
  const lastValueRef = useRef(value);

  // Focus/select handling
  useEffect(() => {
    if (!inputRef.current) return;
    if (props.autoFocus) inputRef.current.focus();
    if (props.autoSelect)
      requestAnimationFrame(() => inputRef.current.select());
  }, [props.autoFocus, props.autoSelect]);

  // Sync external value changes safely
  useEffect(() => {
    if (value !== lastValueRef.current) {
      setTempVal(value ?? '');
      lastValueRef.current = value;
    }
  }, [value]);

  // Debounce tempVal to propagate changes
  useEffect(() => {
    if (tempVal === lastValueRef.current) return;

    const timeoutId = setTimeout(() => {
      const event = { target: { name: props.name, value: tempVal } };
      onChange(event);
      actualValue(tempVal);
      lastValueRef.current = tempVal;
    }, delay);

    return () => clearTimeout(timeoutId);
  }, [tempVal, delay, onChange, actualValue, props.name]);

  const handleChange = e => setTempVal(e.target.value);

  return (
    <TextField
      {...props}
      value={tempVal}
      onChange={handleChange}
      inputRef={inputRef}
    />
  );
};

export default memo(DebounceTextField2);
